module.exports = __webpack_public_path__ + "static/cultivation_operational-46c99ea3ff517584dbac3d52b6257a7c.png";